import { createApp } from "vue";
import App from "./App.vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import store from './store';
import router from "./router";
import 'vue-advanced-cropper/dist/style.css';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import Datepicker from 'vuejs3-datepicker';
import Vue3SimpleHtml2pdf from "vue3-simple-html2pdf";
import VueHtml2pdf from 'vue3-html2pdf';
import '@vuepic/vue-datepicker/dist/main.css';
import "../src/scss/custom.scss";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowLeft,
  faEnvelope,
  faPhone,
  faPen,
  faTrash,
  faUsers,
  faBriefcase,
  faCalendar,
  faPrint,
  faPlus
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faPhone, faEnvelope, faArrowLeft, faPen, faTrash, faUsers, faBriefcase, faCalendar, faPrint, faPlus);

createApp(App)
.component('Datepicker', Datepicker)
.component('font-awesome-icon', FontAwesomeIcon)
.use(Toast)
.use(store)
.use(router)
.use(Vue3SimpleHtml2pdf)
.use(VueHtml2pdf)
// .use(jspdf)
.mount("#app");

